import React, { useContext, useState } from 'react'
import ReactGA from 'react-ga'
import { useHistory, useLocation } from 'react-router-dom'

import SideMenu from '../components/SideMenu'
import ProfileInfo from './components/ProfileInfo'
import ClinicInfo from './components/ClinicInfo'
import Card from '../../../components/Card'

import { SISTEM_ACTIONS } from './constants'
import VaccineHistory from './components/VaccineHistory'
import { RootContext } from '../../../context/rootContext'

import * as S from './styles'
import NewTutorModal from '../components/Modals/NewTutorModal'
import IsMobileModal from '../components/Modals/IsMobileModal'
import SideMenuTemplate from '../templates/SideMenu'

const Home = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isMobileModalVisible, setIsMobileModalVisible] = useState(true)
  const { globalState } = useContext(RootContext)
  const mobileDevices = ['app', 'mobile']
  const isMobile = mobileDevices.includes(new URLSearchParams(useLocation().search).get('source'))
  const history = useHistory()
  const [state] = globalState
  const professional = state.userData.professional
  const userData = state.userData
  const firstName = professional.name.split(' ')[0]

  const showNewTutorForm = () => {
    setIsModalVisible(true)
  }

  const goToAction = (isModal, url) => {
    return isModal ? showNewTutorForm() : goToPage(url)
  }

  const goToPage = (url) => {
    history.push(`/${url}`)
    ReactGA.pageview(`/${url}`)
  }

  return <>
    <SideMenuTemplate>
      <S.MainContainer>
        <S.HeaderInfo>
          <ProfileInfo professional={professional} />
          <ClinicInfo userData={userData} />
        </S.HeaderInfo>
        <S.Main>
          <S.Title>Olá, {firstName}</S.Title>
          <S.SubTitle>O que você gostaria de fazer agora?</S.SubTitle>
          <S.Actions>
            {SISTEM_ACTIONS.map(item =>
              <Card key={item.title}>
                <S.WrapperCard isEnable={item.isEnabled}>
                  <S.CardImage>{item.icon}</S.CardImage>
                  <S.CardTitle>{item.title}</S.CardTitle>
                  <S.CardSubtitle>{item.subtitle}</S.CardSubtitle>
                  {item.isEnabled
                    ? <S.StyledActionButton onClick={() => goToAction(item.showModal, item.url)}>Começar</S.StyledActionButton>
                    : <S.StyledActionButton>Em breve</S.StyledActionButton>
                  }
                </S.WrapperCard>
              </Card>
            )}
          </S.Actions>
          <VaccineHistory />
        </S.Main>
      </S.MainContainer>
    </SideMenuTemplate>
    <NewTutorModal visibility={isModalVisible} setVisibility={setIsModalVisible} />
    <IsMobileModal visibility={isMobile && isMobileModalVisible} setVisibility={() => setIsMobileModalVisible(false)} />
  </>
}

export default Home
